import { Spin } from 'antd'
import { RobotOutlined } from '@ant-design/icons'

export function InsightCard({
  insight,
  isLoading,
  label = 'PracIntel Insight',
}: {
  insight?: string
  isLoading: boolean
  label?: string
}) {
  return (
    <div className="feature-panel-soft rounded-xl p-4">
      <div className="flex items-center mb-2">
        <div className="flex items-center gap-2">
          <RobotOutlined className="feature-icon-accent" />
          <span className="feature-label-accent text-xs font-semibold uppercase tracking-wide">{label}</span>
        </div>
      </div>
      {isLoading ? (
        <div className="feature-soft-text flex items-center gap-2 text-sm">
          <Spin size="small" />
          <span>Generating insight…</span>
        </div>
      ) : insight ? (
        <p className="text-sm text-gray-700 leading-relaxed">{insight}</p>
      ) : (
        <p className="text-sm text-gray-400">No insight available.</p>
      )}
    </div>
  )
}
